//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContactUs from "@views/footer/src/components/ContactUs";
import FloatingLayer from "@views/footer/src/components/FloatingLayer";
import { solutionsMenu } from "@views/home-page/src/constant";

export default {
  name: "Footer",
  components: {FloatingLayer, ContactUs },
  data() {
    return {
      contactUsVisible: false,
      solutionsMenu
    }
  },
  methods: {
    handleContact() {
      this.contactUsVisible = true
    }
  }
}
